var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Flux360"}},[_c('div',{staticClass:"render-level"},[_c('RenderController'),_c('Renderer',{staticClass:"full-screen"},[_c('PanoramaScene')],1)],1),_c('div',{staticClass:"ui-level",staticStyle:{"background":"transparent","display":"none","pointer-events":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }